import { render, staticRenderFns } from "./ProformaDetailDialog.vue?vue&type=template&id=1a0ea5f2"
import script from "./ProformaDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProformaDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports